import { useParams } from 'react-router'
import React from 'react'
import TherapistRosterPage from 'src/supportPortal/views/therapistRoster/TherapistRosterPage'

export default function SingleTherapistRoster() {
  const { mentorSlug } = useParams()

  return <TherapistRosterPage preSelectedMentorSlug={mentorSlug} hideMentorSelectionDropDown />
}
